import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-100">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-live-line text-lg" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                蜜梨直播
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              蜜梨直播，专注于提供多元化、高质量直播内容的互动直播平台，涵盖娱乐表演、网络游戏、才艺展示与用户交流互动。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">关于平台</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  用户互动帮助
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  搜索直播
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500" />
                support@mili-live.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-feedback-line text-base text-primary-500" />
                意见反馈：feedback@mili-live.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-primary-500" />
                客服在线时间：每日 09:00 - 23:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-300/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 蜜梨直播 · 本站为演示站点，所有直播内容与主播均为虚构演示数据。</p>
          <p>高清互动直播在线观看平台</p>
        </div>
      </div>
    </footer>
  );
}